"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionalSearchWithArrayPipe = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
let OptionalSearchWithArrayPipe = class OptionalSearchWithArrayPipe {
    constructor() {
    }
    transform(value, key, searchTerms, onOff) {
        if (value) {
            if (typeof onOff != 'undefined' && onOff == true) {
                if (key) {
                    if (searchTerms && searchTerms.length > 0) {
                        return value.filter(item => {
                            if (item[key] != 'undefined') {
                                for (let sT in searchTerms) {
                                    if ((item[key].trim() == searchTerms[sT].trim()) || (item[key].replace(/\([^()]*\)/g, '').trim() == searchTerms[sT].trim())) {
                                        return true;
                                    }
                                }
                            }
                            return false;
                        });
                    }
                }
            }
            return value;
        }
    }
};
exports.OptionalSearchWithArrayPipe = OptionalSearchWithArrayPipe;
exports.OptionalSearchWithArrayPipe = OptionalSearchWithArrayPipe = __decorate([
    (0, core_1.Pipe)({ name: 'optionalSearchWithArray' }),
    __metadata("design:paramtypes", [])
], OptionalSearchWithArrayPipe);
//# sourceMappingURL=optional-search-with-array.pipe.js.map